import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { WarningToastProps } from '@helpers/Models';
import { faWarning } from '@fortawesome/free-solid-svg-icons';

export const WarningToast: React.FC<WarningToastProps> = ({
  title,
  message,
  onClose,
  onFinish,
}) => (
  <div
    className="fixed top-4 right-4 w-72 bg-white border rounded-lg shadow-lg z-0"
    role="alert"
    aria-live="assertive"
  >
    {/* Header */}
    <div className="flex items-center justify-between px-4 py-2 rounded-t-lg">
      <div className="flex items-center gap-2">
        <FontAwesomeIcon icon={faWarning} className="text-yellow-200" />
        <h2 className="font-semibold text-sm">{title}</h2>
      </div>
      <button
        type="button"
        onClick={onClose}
        aria-label="Close"
        className="text-gray-600 hover:text-gray-700 focus:outline-none"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
            clipRule="evenodd"
          />
        </svg>
      </button>
    </div>
    {/* Body */}
    <div className="px-4 py-3">
      <p className="text-sm text-gray-800">{message}</p>
    </div>
    {/* Action Buttons */}
    <div className="flex justify-end px-4 py-3 rounded-b-lg">
      <button
        onClick={onFinish}
        type="button"
        className="w-[50%] px-6 py-2 border border-transparent rounded-md text-sm font-medium text-white bg-primary hover:bg-dark-primary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary flex items-center justify-center space-x-2"
      >
        Finish
      </button>
      <button
        type="button"
        onClick={onClose}
        className="ml-2 text-gray-700 text-sm font-semibold px-4 py-2 rounded-md hover:bg-gray-200 transition"
      >
        Cancel
      </button>
    </div>
  </div>
);
